import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Content } from '../../../infrastructure/content';
import SalesField from '../../businessFinanceQuestion/components/SalesField';
import CostToStartBusiness from '../../businessFinanceQuestion/components/CostToStartBusiness';
import FundsToStartBusiness from '../../businessFinanceQuestion/components/FundsToStartBusiness';
import {
  getLabelByKey,
  COST_TO_START_BUSINESS
} from '../../businessFinanceQuestion/businessFinanceUtil';
import AnotherBankAccount from '../../businessFinanceQuestion/components/AnotherBankAccount';
import SortCodeField from '../../businessFinanceQuestion/components/SortCodeField';
import SwitchingBankAccount from '../../businessFinanceQuestion/components/SwitchingBankAccount';
import AccountNumber from '../../businessFinanceQuestion/components/AccountNumber';
import DateField from '../../../components/DateField';
import { isTradingLessThanSixMonths } from '../../../utils/validation';
import { onKeyPress } from '../../../utils';
class BusinessFinancesAccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEdit: false };
    this.saveBusinessFinanceChanges = this.saveBusinessFinanceChanges.bind(this);
    this.businessFinanceEditClick = this.businessFinanceEditClick.bind(this);
  }
  businessFinanceEditClick() {
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(false);
  }

  renderBusinessFinanceType(values) {
    const { getBusinessData } = this.props;
    if (!this.state.isEdit) {
      const getDescriptionList = (
        businessSales,
        dateFieldHeader,
        costToStartBusiness,
        fundsToStartBusiness,
        accountWithOtherBankHeader,
        switchingBankHeader,
        sortCodeHeader,
        accountNumberHeader
      ) => {
        const items = [];

        items.push({
          key: businessSales,
          value: getBusinessData.annualSales && getBusinessData.annualSales
        });
        items.push({
          key: dateFieldHeader,
          value: getBusinessData.beginTrading
            ? `${getBusinessData.beginTrading.dateField}-${getBusinessData.beginTrading.monthField}-${getBusinessData.beginTrading.yearField}`
            : ''
        });
        if (
          getBusinessData.beginTrading &&
          isTradingLessThanSixMonths(getBusinessData.beginTrading)
        ) {
          items.push({
            key: costToStartBusiness,
            value: getLabelByKey(getBusinessData.costToStartBusiness, COST_TO_START_BUSINESS)
          });
          items.push({
            key: fundsToStartBusiness,
            value: getLabelByKey(getBusinessData.fundsToStartBusiness)
          });
        }

        items.push({ key: accountWithOtherBankHeader, value: getBusinessData.anotherBankAccount });
        getBusinessData.anotherBankAccount === 'Yes' &&
          getBusinessData.switchingBankAccount &&
          items.push({ key: switchingBankHeader, value: getBusinessData.switchingBankAccount });

        if (
          getBusinessData.switchingBankAccount === 'Yes' &&
          getBusinessData.anotherBankAccount === 'Yes'
        ) {
          getBusinessData.hasOwnProperty('sortCode') &&
            items.push({
              key: sortCodeHeader,
              value: `${getBusinessData.sortCode.sortField1}-${getBusinessData.sortCode.sortField2}-
              ${getBusinessData.sortCode.sortField3}`
            });
          getBusinessData.hasOwnProperty('accountNumber') &&
            items.push({ key: accountNumberHeader, value: getBusinessData.accountNumber });
        }
        return items;
      };

      return (
        <Content>
          {({
            businessSales,
            dateFieldHeader,
            costToStartBusiness,
            fundsToStartBusiness,
            accountWithOtherBankHeader,
            switchingBankHeader,
            sortCodeHeader,
            accountNumberHeader
          }) => (
            <GenericDescriptionList
              items={getDescriptionList(
                businessSales,
                dateFieldHeader,
                costToStartBusiness,
                fundsToStartBusiness,
                accountWithOtherBankHeader,
                switchingBankHeader,
                sortCodeHeader,
                accountNumberHeader
              )}
            />
          )}
        </Content>
      );
    }
    return (
      <div>
        <SalesField formFieldValues={values} />
        <DateField dateHeader="beginTrading" />
        {values.beginTrading && isTradingLessThanSixMonths(values.beginTrading) && (
          <div>
            <CostToStartBusiness value={values.costToStartBusiness} />
            <FundsToStartBusiness formFieldValues={values} />
          </div>
        )}
        <AnotherBankAccount formFieldValues={values} />
        {values.anotherBankAccount === 'Yes' && <SwitchingBankAccount formFieldValues={values} />}
        {values.switchingBankAccount === 'Yes' && values.anotherBankAccount === 'Yes' && (
          <div>
            <SortCodeField />
            <AccountNumber />
          </div>
        )}
      </div>
    );
  }
  saveBusinessFinanceChanges(e) {
    this.props.saveBusinessFinanceChanges(e);
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(true);
  }
  render() {
    const { getBusinessData, onValueChanges, linkCode, onCancelEditClick } = this.props;
    const { isEdit } = this.state;
    return (
      <div>
        <Form
          onSubmit={this.saveBusinessFinanceChanges}
          initialValues={getBusinessData}
          render={({ handleSubmit, values }) => (
            <form
              onSubmit={handleSubmit}
              onKeyPress={onKeyPress}
              onChange={() => {
                onValueChanges(true);
              }}
            >
              {this.renderBusinessFinanceType(values)}
              {isEdit && (
                <Content>
                  {({ confirmChanges, changesNotSavedText }) => (
                    <div className="u-margin-top-2 u-margin-bottom-2">
                      <ActionButton.Primary
                        labelText={confirmChanges}
                        onClick={() => this.saveBusinessFinanceChanges(values)}
                      />
                      <p>{changesNotSavedText}</p>
                    </div>
                  )}
                </Content>
              )}
            </form>
          )}
        />
        {!linkCode && (
          <div className="u-margin-bottom-2">
            <NavigationButton.Tertiary
              labelText={!isEdit ? 'Edit' : 'Cancel Editing'}
              onClick={(e) => {
                e.preventDefault();
                if (isEdit) {
                  onCancelEditClick();
                }
                this.businessFinanceEditClick();
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
export default BusinessFinancesAccordionItem;
